import React, { PureComponent } from 'react'
import { connect } from 'redaction'
import { compose, getProjectName, links } from 'helpers'
import injectGlobals from 'local_modules/injectGlobals'
import actions from 'redux/actions'

import Link from 'components/ui/Link/Link'

import LayersToggleLink from '../LayersToggleLink/LayersToggleLink'

import s from './LayersHeading.scss'


const getEduCashierSchool = (state) => {
  const {
    me: { id },
    marketplace: {
      accessLevel: { edu: { cashierAccessLevel } },
    }
  } = state

  return (cashierAccessLevel.find(({ cashier }) => cashier.id === id) || {}).school
}

const getRpcCashierSchool = (state) => {
  const {
    me: { id },
    marketplace: {
      accessLevel: { rpc: { cashierAccessLevel } },
    }
  } = state

  return (cashierAccessLevel.find(({ cashier }) => cashier.id === id) || {}).school
}


class LayersHeading extends PureComponent {

  UNSAFE_componentWillMount() {
    const { isMobile, projectName, toggleClose } = this.props

    if (isMobile && projectName === 'marketplace') {
      toggleClose()
    }
  }

  render() {
    const {
      children,
      projectName, marketplaceToolAndArea,
      isLoggedIn, isCashierWebView, isToggleActive, toggleOpen, toggleClose,
    } = this.props

    const isMarketplace = projectName === 'marketplace'

    return (
      <div className={s.layers}>
        <LayersToggleLink
          title="Слои"
          arrowDirection={isToggleActive ? 'down' : 'up'}
          onClick={isToggleActive ? toggleClose : toggleOpen}
        />
        {
          Boolean(isMarketplace && marketplaceToolAndArea) && (
            <div className={s.marketplaceToolAndArea}>{marketplaceToolAndArea}</div>
          )
        }
        {
          isCashierWebView && (
            <div
              className="flex justify-end pr-20"
              style={{ flex: '1 1 0' }}
            >
              <Link
                title={isLoggedIn ? 'Выход' : 'Вход'}
                to={isLoggedIn ? null : links.marketplace.login}
                onClick={() => {
                  if (isLoggedIn) {
                    actions.me.exit()
                      .then(() => actions.router.push(links.marketplace.customer.schedule))
                  }
                }}
              />
            </div>
          )
        }
        {children}
      </div>
    )
  }
}


export default compose(
  injectGlobals(({ globals, getCookieValue }) => ({
    isMobile: globals.isMobile,
    isCashierWebView: Boolean(getCookieValue('isCashierWebView')),
  })),
  connect({
    isLoggedIn: 'me.isLoggedIn',
    projectName: (state) => getProjectName(state),
    marketplaceToolAndArea: (state) => {
      const { marketplace: { layersNavigation: { category, tools, toolType, tool, area, nomenclature, rpcNomenclature } } } = state

      if (category === 'sport') {
        const selectedTool = tools.find(({ id }) => id === toolType)

        if (selectedTool) {
          const toolName = selectedTool.name

          let areaName
          let areaShortName

          selectedTool.areas.find(({ id, name, area: { id: areaId, shortName } }) => {
            if (areaId === area && id === tool) {
              areaName = name
              return areaShortName = shortName
            }
          })

          if (areaShortName) {
            return areaName ? `${toolName} (${areaShortName}) - ${areaName}` : `${toolName} (${areaShortName})`
          }

          return `${toolName}`
        }
      }
      else if (category === 'edu') {
        const selectedTool  = nomenclature.find(({ id }) => id === toolType)
        const cashierSchool = getEduCashierSchool(state)

        let text = ''

        if (selectedTool) {
          text = `${selectedTool.title}`
        }

        if (cashierSchool) {
          text += ` / школа ${cashierSchool.title}`
        }

        return text
      } else if (category === 'rpc') {
        const selectedTool  = rpcNomenclature.find(({ id }) => id === toolType)
        const cashierSchool = getRpcCashierSchool(state)

        let text = ''

        if (selectedTool) {
          text = `${selectedTool.title}`
        }

        if (cashierSchool) {
          text += ` / школа ${cashierSchool.title}`
        }

        return text
      }

      return ''
    },
  }),
)(LayersHeading)
